export interface IGraphicLink {
  linkUrl: string;
  linkLabel: string;
  graphicUrl?: string;
  graphicAltText?: string;
  background?: GraphicLinkContentStyle;
}

export enum GraphicLinkContentStyle {
  blank = 'blank',
  filled = 'filled',
}
